export function createRFQData({
  user,
  cart,
  notes,
  designId,
  quoteType,
}: {
  user: any;
  cart: any;
  notes: any;
  designId?: any;
  quoteType?: string[] | null;
}) {
  // Use the passed designId (already validated) or fall back to cart.designId or empty string
  // Priority: validated designId parameter > cart.designId > empty string
  const finalDesignId = designId !== undefined ? designId : cart.designId || "";

  // Construct customer name from first_name and last_name (handles both camelCase and snake_case)
  const firstName = user.first_name || user.firstName || "";
  const lastName = user.last_name || user.lastName || "";
  const customerName =
    [firstName, lastName].filter(Boolean).join(" ").trim() || user.name || "";

  return {
    designId: finalDesignId,
    quoteType: quoteType ?? [],

    customer: {
      customer_name: customerName,
      customer_company_name: user.company || "",
      customer_zip: user.zip,
      customer_city: user.city,
      customer_state: user.state,
      customer_street_address: user.street,
      customer_email: user.email,
      customer_phone: user.phone || user.phone_number || "",
      customer_id: user.id,
    },

    template: {
      id: cart.templateId || "",
      project_name: cart.projectName || "",
      notes: notes || "",
      signature_text: cart.signatureText || "",
      footer: cart.footer || "",
      viewUrl: finalDesignId ? createViewerUrl(finalDesignId) : "",
      vat_rate: cart.vatRate ?? 0,
    },

    items: cart.data.map((item: any) => ({
      pn: item.partNumber,
      // Use the descriptive name if available, otherwise fall back to part number
      name: item.name || item.partNumber,
      qty: item.qty,
      color: item.color || "",
      length: item.length || "",
      length_unit: item.length_unit || "",
      item_price: item?.each ?? 0,
      ProductPriceTotal: item?.total ?? 0,
      Total: item?.total ?? 0,
    })),

    designData: cart?.contents || null,
  };
}

function createViewerUrl(designId: string) {
  return `https://layout-dev.xmicrowave.com/?view-design?${designId}`;
}
